import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const getDocumentCaptureResultAPI = async ({subsidiaryId, resultToken}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/document-capture/session/${encodeURIComponent(resultToken)}/result`;
    const METHOD = "GET";
    const HEADERS = {
        Accept: "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {getDocumentCaptureResultAPI};
